import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import User from 'flarum/common/models/User';
import AuditBrowser from '../../common/components/AuditBrowser';

interface ActorAuditModalAttrs extends IInternalModalAttrs {
    user: User
}

export default class ActorAuditModal extends Modal<ActorAuditModalAttrs> {
    className() {
        return 'AuditModal ActorAuditModal';
    }

    title() {
        return app.translator.trans('kilowhat-audit.forum.modal.actor-title');
    }

    content() {
        return AuditBrowser.component({
            baseQ: 'actor:' + this.attrs.user.username(),
        });
    }
}
